import type {ReactElement} from 'react';
import React from 'react';
import {BaseItemContrastOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-contrast-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromEffectsActiveItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveItem';

export function ItemContrastOption(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemContrast = useGetKeyFromEffectsActiveItem('contrast');

  if (!activeItem || (activeItem && !('effects' in activeItem)) || activeItemContrast === undefined) {
    throw new Error(`Item doesn't have effects property`);
  }

  const updateContrast = (contrast: number, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        effects: {
          contrast,
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseItemContrastOption contrast={activeItemContrast} updateContrast={updateContrast} />;
}
